import { omit } from 'lodash'

import api from 'api'
import { stampPlacementFlagsOnList } from 'components/inventory/containers/__mocks__/placementFlags'

import { CACHE_TAG_CONFIGURED_SERVICE_CONTAINER_LIST } from '../cacheTagTypes'

import type { ContainerListResponseApi } from 'types/api/container/container'
import type { BulkConfiguredServiceContainerLinkBody, ConfiguredServiceContainerLinkArgs } from 'types/api/container/containerRequests'

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    getConfiguredServiceContainers: builder.query<ContainerListResponseApi, { configuredServiceId: string }>({
      query: ({ configuredServiceId }) => ({
        url: `/api/v1/core/configured-service/${configuredServiceId}/container`,
        method: 'GET',
      }),
      transformResponse: stampPlacementFlagsOnList<ContainerListResponseApi>,
      providesTags: [CACHE_TAG_CONFIGURED_SERVICE_CONTAINER_LIST],
    }),
    assignConfiguredServiceContainer: builder.mutation<ContainerListResponseApi, ConfiguredServiceContainerLinkArgs>({
      query: ({ configuredServiceId, ...rest }) => ({
        url: `/api/v1/core/configured-service/${configuredServiceId}/container/assign`,
        method: 'POST',
        body: omit(rest, ['skipInvalidate']),
      }),
      invalidatesTags: (result, error, arg) => (arg?.skipInvalidate ? [] : [CACHE_TAG_CONFIGURED_SERVICE_CONTAINER_LIST]),
    }),
    unassignConfiguredServiceContainer: builder.mutation<ContainerListResponseApi, ConfiguredServiceContainerLinkArgs>({
      query: ({ configuredServiceId, ...rest }) => ({
        url: `/api/v1/core/configured-service/${configuredServiceId}/container/unassign`,
        method: 'POST',
        body: omit(rest, ['skipInvalidate']),
      }),
      invalidatesTags: (result, error, arg) => (arg?.skipInvalidate ? [] : [CACHE_TAG_CONFIGURED_SERVICE_CONTAINER_LIST]),
    }),
    bulkAssignConfiguredServiceContainer: builder.mutation<ContainerListResponseApi, BulkConfiguredServiceContainerLinkBody>({
      query: body => ({
        url: '/api/v1/core/configured-service/container/assign/bulk',
        method: 'POST',
        body,
      }),
      invalidatesTags: [],
    }),
    bulkUnassignConfiguredServiceContainer: builder.mutation<ContainerListResponseApi, BulkConfiguredServiceContainerLinkBody>({
      query: body => ({
        url: '/api/v1/core/configured-service/container/unassign/bulk',
        method: 'POST',
        body,
      }),
      invalidatesTags: [],
    }),
  }),
})

export const {
  useGetConfiguredServiceContainersQuery,
  useLazyGetConfiguredServiceContainersQuery,
  useAssignConfiguredServiceContainerMutation,
  useUnassignConfiguredServiceContainerMutation,
  useBulkAssignConfiguredServiceContainerMutation,
  useBulkUnassignConfiguredServiceContainerMutation,
} = extendedApi
